module.exports = __webpack_public_path__ + "9b0077c44069dae0d437ac9916d1d051.woff2";